import styled, { css } from 'styled-components';
import { colors, cssprops, pxToRem } from '@vfit/shared/themes';
import { IFrameInputForStyled } from './frameInput.models';
import { checkbox, radio } from '../../inputs.style';

const variants = {
  label: {
    primary: css`
      border-radius: ${pxToRem(6)};
      padding: ${pxToRem(20, 16)};
    `,
    secondary: css`
      border-radius: ${pxToRem(10)};
      padding: ${pxToRem(16, 24)};
    `,
    tertiary: css`
      border-radius: ${pxToRem(20)};
      padding: ${pxToRem(16, 24)};
    `,
  },
  input: {
    primary: css`
      margin-right: ${pxToRem(8)};
    `,
    secondary: css`
      margin-right: ${pxToRem(24)};
    `,
    tertiary: css`
      margin-right: ${pxToRem(24)};
    `,
  },
};

export const Label = styled.label<IFrameInputForStyled>`
  align-items: center;
  border: 1px solid ${colors.$bebebe};
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')};
  display: flex;
  ${({ variant }) => (variant ? variants.label[variant] : '')}

  &.checked {
    border-color: ${colors.$00697c};
    box-shadow: 0 0 0 1px ${colors.$00697c};
  }

  ${cssprops.styled}
`;

export const Input = styled.input<IFrameInputForStyled>`
  ${({ type }) => (type === 'radio' ? radio : checkbox)}
  ${({ control }) => (control ? '' : 'display: none;')}
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')};
  ${({ variant }) => (variant ? variants.input[variant] : '')}
`;

